package com.perpheads.bans.wrappers

import js.objects.jso
import web.cssom.MediaQuery


fun useMediaQuery(mediaQuery: MediaQuery) = useMediaQuery(jso<UseMediaQueryProps> { query = mediaQuery })